/**
 * The provenance marker a migrated Agentic Logic rule carries in its
 * `description`, and how to take it back out again for display.
 *
 * The marker has to live in `description` because that is the only durable
 * link from a published rule back to the legacy container it was built for —
 * the container points at a PLACEMENT once mapped, and before the mapping
 * exists there is no edge in that direction at all.
 *
 * That makes `description` both machine state and merchant-facing copy, so the
 * prefix and the stripping live HERE, shared, rather than being re-implemented
 * with a second regex on the rendering side.
 */

export const MIGRATION_MARKER_PREFIX = "[legacy-upsell-migration:v1:";

/**
 * A rule description with its provenance marker removed, for display to a
 * person. A merchant-authored description carries no marker and comes back
 * unchanged apart from trimming.
 */
export function stripMigrationProvenanceMarker(
  description: string | null | undefined
): string {
  if (!description) {
    return "";
  }
  const start = description.indexOf(MIGRATION_MARKER_PREFIX);
  if (start === -1) {
    return description.trim();
  }
  const end = description.indexOf("]", start);
  if (end === -1) {
    // An unterminated marker is corrupt, not a marker. Showing the raw text
    // beats silently swallowing the rest of the description.
    return description.trim();
  }
  return `${description.slice(0, start)}${description.slice(end + 1)}`
    .replace(/\s+/g, " ")
    .trim();
}
